
import { STRONG_8K, NXT, MEGA_OTT, TRILLO, APP_SERVICES, PLATFORM_NAMES } from "./platforms"

// ULTIMATE
const DIAMOND_PACKAGE_HEX = "#638ed4"; // Strong 8k
const PLATINUM_PACKAGE_HEX = "#79b2d1"; // NXT
const EMERALD_PACKAGE_HEX = "#51e54b"; // MegaOTT
const SILVER_PACKAGE_HEX = "#c0c0c0"; // Trillo

// EXPERIENCE
const EARTH_PACKAGE_HEX = "#c0c0c0"; // Strong 8k
const WIND_PACKAGE_HEX = "#51e54b"; // MegaOTT
const FIRE_PACKAGE_HEX = "#638ed4"; // NXT
const WATER_PACKAGE_HEX = "#638ed4"; // Trillo

// EXTREME
const EXTREME_PACKAGE_HEX = "#e0a5a5"; // NXT
const TITAN_PACKAGE_HEX = "#ed5a5a"; // MegaOTT
const DUST_PACKAGE_HEX = "#9c9b9b"; // Strong 8k
const VENGENCE_PACKAGE_HEX = "#7a1f1f"; // Trillo

// NECTAR
const NECTAR_PACKAGE_HEX = "#c3ae5b"; // NXT
const HONEY_POT_PACKAGE_HEX = "#caa923"; // MegaOTT
const HIVE_PACKAGE_HEX = "#f2a900"; // Trillo
const GOLDEN_PACKAGE_HEX = "#e5dda5"; // Strong8k

// VULTURE
const VULTURE_PACKAGE_HEX = "#74665d"; // NXT
const SHADOW_PACKAGE_HEX = "#414141"; // MegaOTT
const MIST_PACKAGE_HEX = "#b6b6b6"; // Trillo

// APP SERVICES
const TIVIMATE_ACCESS_HEX  = "#8B5CF6";
const TIVIMATE_BRANDED_HEX = "#6D28D9";
const IBO_ACCESS_HEX       = "#EC4899";
const IBO_BRANDED_HEX      = "#BE185D";
const SMARTERS_ACCESS_HEX  = "#F59E0B";
const SMARTERS_BRANDED_HEX = "#B45309";
const XCIPTV_ACCESS_HEX    = "#10B981";
const XCIPTV_BRANDED_HEX   = "#047857";

const packages = new Map([

  // ULTIMATE EXPERIENCE
  ['Diamond', {
    color: DIAMOND_PACKAGE_HEX,
    platform: STRONG_8K,
    creditCost: 1.87,
    options: {
      1000: { name: "One Device 24 Months", price: 120.00, credits: 24 },
      1001: { name: "One Device 12 Months", price: 80.00, credits: 12 },
      1002: { name: "One Device 6 Months", price: 50.00, credits: 6 },
      1003: { name: "One Device 3 Months", price: 30.00, credits: 3 },
      1004: { name: "One Device 1 Month", price: 15.00, credits: 1 },

      1005: { name: "Two Device 24 Months", price: 210.00, credits: 48 },
      1006: { name: "Two Device 12 Months", price: 115.00, credits: 24 },
      1007: { name: "Two Device 6 Months", price: 80.00, credits: 12 },
      1008: { name: "Two Device 3 Months", price: 50.00, credits: 6 },
      1009: { name: "Two Device 1 Month", price: 20.00, credits: 2 },

      1010: { name: "Three Device 24 Months", price: 290.00, credits: 72 },
      1011: { name: "Three Device 12 Months", price: 175.00, credits: 36 },
      1012: { name: "Three Device 6 Months", price: 95.00, credits: 18 },
      1013: { name: "Three Device 3 Months", price: 55.00, credits: 9 },
      1014: { name: "Three Device 1 Month", price: 25.00, credits: 3 },

      1015: { name: "Four Device 24 Months", price: 380.00, credits: 96 },
      1016: { name: "Four Device 12 Months", price: 230.00, credits: 48 },
      1017: { name: "Four Device 6 Months", price: 150.00, credits: 24 },
      1018: { name: "Four Device 3 Months", price: 80.00, credits: 12 },
      1019: { name: "Four Device 1 Month", price: 30.00, credits: 4 },

      1020: { name: "Five Device 24 Months", price: 480.00, credits: 120 },
      1021: { name: "Five Device 12 Months", price: 290.00, credits: 60 },
      1022: { name: "Five Device 6 Months", price: 190.00, credits: 30 },
      1023: { name: "Five Device 3 Months", price: 100.00, credits: 15 },
      1024: { name: "Five Device 1 Month", price: 35.00, credits: 5 },

      1025: { name: "Six Device 24 Months", price: 570.00, credits: 144 },
      1026: { name: "Six Device 12 Months", price: 345.00, credits: 72 },
      1027: { name: "Six Device 6 Months", price: 225.00, credits: 36 },
      1028: { name: "Six Device 3 Months", price: 120.00, credits: 18 },
      1029: { name: "Six Device 1 Month", price: 40.00, credits: 6 },

    }
  }],
  ['Platinum', {
    color: PLATINUM_PACKAGE_HEX,
    platform: NXT,
    creditCost: 3.80,
    options: {
      2001: { name: "One Device 24 Months", price: 140.00, credits: 8 },
      2002: { name: "One Device 12 Months", price: 90.00, credits: 4 },
      2003: { name: "One Device 6 Months", price: 60.00, credits: 3 },
      2004: { name: "One Device 3 Months", price: 35.00, credits: 2 },
      2005: { name: "One Device 1 Month", price: 20.00, credits: 1 },

      2006: { name: "Two Device 24 Months", price: 230.00, credits: 14 },
      2007: { name: "Two Device 12 Months", price: 125.00, credits: 7 },
      2008: { name: "Two Device 6 Months", price: 90.00, credits: 5 },
      2009: { name: "Two Device 3 Months", price: 55.00, credits: 4 },
      2010: { name: "Two Device 1 Month", price: 25.00, credits: 2 },

      2011: { name: "Three Device 24 Months", price: 290.00, credits: 20 },
      2012: { name: "Three Device 12 Months", price: 175.00, credits: 10 },
      2013: { name: "Three Device 6 Months", price: 100.00, credits: 7 },
      2014: { name: "Three Device 3 Months", price: 60.00, credits: 6 },
      2015: { name: "Three Device 1 Month", price: 30.00, credits: 3 },

      2016: { name: "Four Device 24 Months", price: 400.00, credits: 26 },
      2017: { name: "Four Device 12 Months", price: 250.00, credits: 13 },
      2018: { name: "Four Device 6 Months", price: 180.00, credits: 9 },
      2019: { name: "Four Device 3 Months", price: 95.00, credits: 8 },
      2020: { name: "Four Device 1 Month", price: 35.00, credits: 4 },

      2021: { name: "Five Device 24 Months", price: 550.00, credits: 40 },
      2022: { name: "Five Device 12 Months", price: 300.00, credits: 20 },
      2023: { name: "Five Device 6 Months", price: 200.00, credits: 12 },
      2024: { name: "Five Device 3 Months", price: 125.00, credits: 10 },
      2025: { name: "Five Device 1 Month", price: 40.00, credits: 5 },

      2026: { name: "Six Device 24 Months", price: 650.00, credits: 48 },
      2027: { name: "Six Device 12 Months", price: 325.00, credits: 24 },
      2028: { name: "Six Device 6 Months", price: 220.00, credits: 18 },
      2029: { name: "Six Device 3 Months", price: 135.00, credits: 12 },
      2030: { name: "Six Device 1 Month", price: 45.00, credits: 6 },

    }
  }],
  ['Emerald', {
    color: EMERALD_PACKAGE_HEX,
    platform: MEGA_OTT,
    creditCost: 10,
    options: {
      8000: { name: "One Device 24 Months", price: 140.00, credits: 1.8 },
      8001: { name: "One Device 12 Months", price: 90.00, credits: 1 },
      8002: { name: "One Device 6 Months", price: 60.00, credits: 0.5 },
      8003: { name: "One Device 3 Months", price: 35.00, credits: 0.25 },
      8004: { name: "One Device 1 Month", price: 20.00, credits: 0.1 },

      8005: { name: "Two Device 24 Months", price: 230.00, credits: 3.6 },
      8006: { name: "Two Device 12 Months", price: 125.00, credits: 2 },
      8007: { name: "Two Device 6 Months", price: 90.00, credits: 1 },
      8008: { name: "Two Device 3 Months", price: 55.00, credits: 0.5 },
      8009: { name: "Two Device 1 Month", price: 25.00, credits: 0.2 },

      8010: { name: "Three Device 24 Months", price: 290.00, credits: 5.4 },
      8011: { name: "Three Device 12 Months", price: 175.00, credits: 3 },
      8012: { name: "Three Device 6 Months", price: 100.00, credits: 1.5 },
      8013: { name: "Three Device 3 Months", price: 60.00, credits: 0.75 },
      8014: { name: "Three Device 1 Month", price: 30.00, credits: 0.3 },

      8015: { name: "Four Device 24 Months", price: 400.00, credits: 7.2 },
      8016: { name: "Four Device 12 Months", price: 250.00, credits: 4 },
      8017: { name: "Four Device 6 Months", price: 180.00, credits: 2 },
      8018: { name: "Four Device 3 Months", price: 95.00, credits: 1 },
      8019: { name: "Four Device 1 Month", price: 35.00, credits: 0.4 },

      8020: { name: "Five Device 24 Months", price: 550.00, credits: 9 },
      8021: { name: "Five Device 12 Months", price: 300.00, credits: 5 },
      8022: { name: "Five Device 6 Months", price: 200.00, credits: 2.5 },
      8023: { name: "Five Device 3 Months", price: 125.00, credits: 1.25 },
      8024: { name: "Five Device 1 Month", price: 40.00, credits: 0.5 },

      8025: { name: "Six Device 24 Months", price: 650.00, credits: 10.8 },
      8026: { name: "Six Device 12 Months", price: 325.00, credits: 6 },
      8027: { name: "Six Device 6 Months", price: 220.00, credits: 3 },
      8028: { name: "Six Device 3 Months", price: 135.00, credits: 1.5 },
      8029: { name: "Six Device 1 Month", price: 45.00, credits: 0.6 },
    }
  }],
  ['Silver', {
    color: SILVER_PACKAGE_HEX,
    platform: TRILLO,
    creditCost: 1.71,
    options: {
      13000: { name: "One Device 24 Months", price: 140.00, credits: 24 },
      13001: { name: "One Device 12 Months", price: 90.00, credits: 12 },
      13002: { name: "One Device 6 Months", price: 60.00, credits: 6 },
      13003: { name: "One Device 3 Months", price: 35.00, credits: 3 },
      13004: { name: "One Device 1 Month", price: 20.00, credits: 1 },

      13005: { name: "Two Device 24 Months", price: 230.00, credits: 48 },
      13006: { name: "Two Device 12 Months", price: 125.00, credits: 14 },
      13007: { name: "Two Device 6 Months", price: 90.00, credits: 8 },
      13008: { name: "Two Device 3 Months", price: 55.00, credits: 4 },
      13009: { name: "Two Device 1 Month", price: 25.00, credits: 2 },

      13010: { name: "Three Device 24 Months", price: 290.00, credits: 72 },
      13011: { name: "Three Device 12 Months", price: 175.00, credits: 16 },
      13012: { name: "Three Device 6 Months", price: 100.00, credits: 10 },
      13013: { name: "Three Device 3 Months", price: 60.00, credits: 6 },
      13014: { name: "Three Device 1 Month", price: 30.00, credits: 3 },

      13015: { name: "Four Device 24 Months", price: 400.00, credits: 96 },
      13016: { name: "Four Device 12 Months", price: 250.00, credits: 18 },
      13017: { name: "Four Device 6 Months", price: 180.00, credits: 12 },
      13018: { name: "Four Device 3 Months", price: 95.00, credits: 8 },
      13019: { name: "Four Device 1 Month", price: 35.00, credits: 4 },

      13020: { name: "Five Device 24 Months", price: 550.00, credits: 120 },
      13021: { name: "Five Device 12 Months", price: 300.00, credits: 20 },
      13022: { name: "Five Device 6 Months", price: 200.00, credits: 14 },
      13023: { name: "Five Device 3 Months", price: 125.00, credits: 10 },
      13024: { name: "Five Device 1 Month", price: 40.00, credits: 5 },

      13025: { name: "Six Device 24 Months", price: 650.00, credits: 144 },
      13026: { name: "Six Device 12 Months", price: 325.00, credits: 72 },
      13027: { name: "Six Device 6 Months", price: 220.00, credits: 36 },
      13028: { name: "Six Device 3 Months", price: 135.00, credits: 18 },
      13029: { name: "Six Device 1 Month", price: 45.00, credits: 6 },
    }
  }],

  // EXPERIENCE IPTV
  ['Earth', {
    color: EARTH_PACKAGE_HEX,
    platform: STRONG_8K,
    creditCost: 1.87,
    options: {
      3000: { name: "One Device 24 Months", price: 120.00, credits: 24 },
      3001: { name: "One Device 12 Months", price: 80.00, credits: 12 },
      3002: { name: "One Device 6 Months", price: 50.00, credits: 6 },
      3003: { name: "One Device 3 Months", price: 30.00, credits: 3 },
      3004: { name: "One Device 1 Month", price: 15.00, credits: 1 },

      3005: { name: "Two Device 24 Months", price: 210.00, credits: 48 },
      3006: { name: "Two Device 12 Months", price: 115.00, credits: 24 },
      3007: { name: "Two Device 6 Months", price: 80.00, credits: 12 },
      3008: { name: "Two Device 3 Months", price: 50.00, credits: 6 },
      3009: { name: "Two Device 1 Month", price: 20.00, credits: 2 },

      3010: { name: "Three Device 24 Months", price: 290.00, credits: 72 },
      3011: { name: "Three Device 12 Months", price: 175.00, credits: 36 },
      3012: { name: "Three Device 6 Months", price: 95.00, credits: 18 },
      3013: { name: "Three Device 3 Months", price: 55.00, credits: 9 },
      3014: { name: "Three Device 1 Month", price: 25.00, credits: 3 },

      3015: { name: "Four Device 24 Months", price: 380.00, credits: 96 },
      3016: { name: "Four Device 12 Months", price: 230.00, credits: 48 },
      3017: { name: "Four Device 6 Months", price: 150.00, credits: 24 },
      3018: { name: "Four Device 3 Months", price: 80.00, credits: 12 },
      3019: { name: "Four Device 1 Month", price: 30.00, credits: 4 },

      3020: { name: "Five Device 24 Months", price: 480.00, credits: 120 },
      3021: { name: "Five Device 12 Months", price: 290.00, credits: 60 },
      3022: { name: "Five Device 6 Months", price: 190.00, credits: 30 },
      3023: { name: "Five Device 3 Months", price: 100.00, credits: 15 },
      3024: { name: "Five Device 1 Month", price: 35.00, credits: 5 },

      3025: { name: "Six Device 24 Months", price: 570.00, credits: 144 },
      3026: { name: "Six Device 12 Months", price: 345.00, credits: 72 },
      3027: { name: "Six Device 6 Months", price: 225.00, credits: 36 },
      3028: { name: "Six Device 3 Months", price: 120.00, credits: 18 },
      3029: { name: "Six Device 1 Month", price: 40.00, credits: 6 },

    }
  }],
  ['Fire', {
    color: FIRE_PACKAGE_HEX,
    platform: NXT,
    creditCost: 3.80,
    options: {
      4001: { name: "One Device 24 Months", price: 140.00, credits: 8 },
      4002: { name: "One Device 12 Months", price: 90.00, credits: 4 },
      4003: { name: "One Device 6 Months", price: 60.00, credits: 3 },
      4004: { name: "One Device 3 Months", price: 35.00, credits: 2 },
      4005: { name: "One Device 1 Month", price: 20.00, credits: 1 },

      4006: { name: "Two Device 24 Months", price: 230.00, credits: 14 },
      4007: { name: "Two Device 12 Months", price: 125.00, credits: 7 },
      4008: { name: "Two Device 6 Months", price: 90.00, credits: 5 },
      4009: { name: "Two Device 3 Months", price: 55.00, credits: 4 },
      4010: { name: "Two Device 1 Month", price: 25.00, credits: 2 },

      4011: { name: "Three Device 24 Months", price: 290.00, credits: 20 },
      4012: { name: "Three Device 12 Months", price: 175.00, credits: 10 },
      4013: { name: "Three Device 6 Months", price: 100.00, credits: 7 },
      4014: { name: "Three Device 3 Months", price: 60.00, credits: 6 },
      4015: { name: "Three Device 1 Month", price: 30.00, credits: 3 },

      4016: { name: "Four Device 24 Months", price: 400.00, credits: 26 },
      4017: { name: "Four Device 12 Months", price: 250.00, credits: 13 },
      4018: { name: "Four Device 6 Months", price: 180.00, credits: 9 },
      4019: { name: "Four Device 3 Months", price: 95.00, credits: 8 },
      4020: { name: "Four Device 1 Month", price: 35.00, credits: 4 },

      4021: { name: "Five Device 24 Months", price: 550.00, credits: 40 },
      4022: { name: "Five Device 12 Months", price: 300.00, credits: 20 },
      4023: { name: "Five Device 6 Months", price: 200.00, credits: 12 },
      4024: { name: "Five Device 3 Months", price: 125.00, credits: 10 },
      4025: { name: "Five Device 1 Month", price: 40.00, credits: 5 },

      4026: { name: "Six Device 24 Months", price: 650.00, credits: 48 },
      4027: { name: "Six Device 12 Months", price: 325.00, credits: 24 },
      4028: { name: "Six Device 6 Months", price: 220.00, credits: 18 },
      4029: { name: "Six Device 3 Months", price: 135.00, credits: 12 },
      4030: { name: "Six Device 1 Month", price: 45.00, credits: 6 },

    }
  }],
  ['Wind', {
    color: WIND_PACKAGE_HEX,
    platform: MEGA_OTT,
    creditCost: 10,
    options: {
      9000: { name: "One Device 24 Months", price: 140.00, credits: 1.8 },
      9001: { name: "One Device 12 Months", price: 90.00, credits: 1 },
      9002: { name: "One Device 6 Months", price: 60.00, credits: 0.5 },
      9003: { name: "One Device 3 Months", price: 35.00, credits: 0.25 },
      9004: { name: "One Device 1 Month", price: 20.00, credits: 0.1 },

      9005: { name: "Two Device 24 Months", price: 230.00, credits: 3.6 },
      9006: { name: "Two Device 12 Months", price: 125.00, credits: 2 },
      9007: { name: "Two Device 6 Months", price: 90.00, credits: 1 },
      9008: { name: "Two Device 3 Months", price: 55.00, credits: 0.5 },
      9009: { name: "Two Device 1 Month", price: 25.00, credits: 0.2 },

      9010: { name: "Three Device 24 Months", price: 290.00, credits: 5.4 },
      9011: { name: "Three Device 12 Months", price: 175.00, credits: 3 },
      9012: { name: "Three Device 6 Months", price: 100.00, credits: 1.5 },
      9013: { name: "Three Device 3 Months", price: 60.00, credits: 0.75 },
      9014: { name: "Three Device 1 Month", price: 30.00, credits: 0.3 },

      9015: { name: "Four Device 24 Months", price: 400.00, credits: 7.2 },
      9016: { name: "Four Device 12 Months", price: 250.00, credits: 4 },
      9017: { name: "Four Device 6 Months", price: 180.00, credits: 2 },
      9018: { name: "Four Device 3 Months", price: 95.00, credits: 1 },
      9019: { name: "Four Device 1 Month", price: 35.00, credits: 0.4 },

      9020: { name: "Five Device 24 Months", price: 550.00, credits: 9 },
      9021: { name: "Five Device 12 Months", price: 300.00, credits: 5 },
      9022: { name: "Five Device 6 Months", price: 200.00, credits: 2.5 },
      9023: { name: "Five Device 3 Months", price: 125.00, credits: 1.25 },
      9024: { name: "Five Device 1 Month", price: 40.00, credits: 0.5 },

      9025: { name: "Six Device 24 Months", price: 650.00, credits: 10.8 },
      9026: { name: "Six Device 12 Months", price: 325.00, credits: 6 },
      9027: { name: "Six Device 6 Months", price: 220.00, credits: 3 },
      9028: { name: "Six Device 3 Months", price: 135.00, credits: 1.5 },
      9029: { name: "Six Device 1 Month", price: 45.00, credits: 0.6 },
    }
  }],
  ['Water', {
    color: WATER_PACKAGE_HEX,
    platform: TRILLO,
    creditCost: 1.00,
    options: {
      15000: { name: "One Device 24 Months", price: 140.00, credits: 24 },
      15001: { name: "One Device 12 Months", price: 90.00, credits: 12 },
      15002: { name: "One Device 6 Months", price: 60.00, credits: 6 },
      15003: { name: "One Device 3 Months", price: 35.00, credits: 3 },
      15004: { name: "One Device 1 Month", price: 20.00, credits: 1 },

      15005: { name: "Two Device 24 Months", price: 230.00, credits: 48 },
      15006: { name: "Two Device 12 Months", price: 125.00, credits: 14 },
      15007: { name: "Two Device 6 Months", price: 90.00, credits: 8 },
      15008: { name: "Two Device 3 Months", price: 55.00, credits: 4 },
      15009: { name: "Two Device 1 Month", price: 25.00, credits: 2 },

      15010: { name: "Three Device 24 Months", price: 290.00, credits: 72 },
      15011: { name: "Three Device 12 Months", price: 175.00, credits: 16 },
      15012: { name: "Three Device 6 Months", price: 100.00, credits: 10 },
      15013: { name: "Three Device 3 Months", price: 60.00, credits: 6 },
      15014: { name: "Three Device 1 Month", price: 30.00, credits: 3 },

      15015: { name: "Four Device 24 Months", price: 400.00, credits: 96 },
      15016: { name: "Four Device 12 Months", price: 250.00, credits: 18 },
      15017: { name: "Four Device 6 Months", price: 180.00, credits: 12 },
      15018: { name: "Four Device 3 Months", price: 95.00, credits: 8 },
      15019: { name: "Four Device 1 Month", price: 35.00, credits: 4 },

      15020: { name: "Five Device 24 Months", price: 550.00, credits: 120 },
      15021: { name: "Five Device 12 Months", price: 300.00, credits: 20 },
      15022: { name: "Five Device 6 Months", price: 200.00, credits: 14 },
      15023: { name: "Five Device 3 Months", price: 125.00, credits: 10 },
      15024: { name: "Five Device 1 Month", price: 40.00, credits: 5 },

      15025: { name: "Six Device 24 Months", price: 650.00, credits: 144 },
      15026: { name: "Six Device 12 Months", price: 325.00, credits: 72 },
      15027: { name: "Six Device 6 Months", price: 220.00, credits: 36 },
      15028: { name: "Six Device 3 Months", price: 135.00, credits: 18 },
      15029: { name: "Six Device 1 Month", price: 45.00, credits: 6 },
    }
  }],

  // EXTREME TV
  ['Extreme', {
    color: EXTREME_PACKAGE_HEX,
    platform: NXT,
    creditCost: 3.80,
    options: {
      5001: { name: "One Device 24 Months", price: 140.00, credits: 8 },
      5002: { name: "One Device 12 Months", price: 90.00, credits: 4 },
      5003: { name: "One Device 6 Months", price: 60.00, credits: 3 },
      5004: { name: "One Device 3 Months", price: 35.00, credits: 2 },
      5005: { name: "One Device 1 Month", price: 20.00, credits: 1 },

      5006: { name: "Two Device 24 Months", price: 230.00, credits: 14 },
      5007: { name: "Two Device 12 Months", price: 125.00, credits: 7 },
      5008: { name: "Two Device 6 Months", price: 90.00, credits: 5 },
      5009: { name: "Two Device 3 Months", price: 55.00, credits: 4 },
      5010: { name: "Two Device 1 Month", price: 25.00, credits: 2 },

      5011: { name: "Three Device 24 Months", price: 290.00, credits: 20 },
      5012: { name: "Three Device 12 Months", price: 175.00, credits: 10 },
      5013: { name: "Three Device 6 Months", price: 100.00, credits: 7 },
      5014: { name: "Three Device 3 Months", price: 60.00, credits: 6 },
      5015: { name: "Three Device 1 Month", price: 30.00, credits: 3 },

      5016: { name: "Four Device 24 Months", price: 400.00, credits: 26 },
      5017: { name: "Four Device 12 Months", price: 250.00, credits: 13 },
      5018: { name: "Four Device 6 Months", price: 180.00, credits: 9 },
      5019: { name: "Four Device 3 Months", price: 95.00, credits: 8 },
      5020: { name: "Four Device 1 Month", price: 35.00, credits: 4 },

      5021: { name: "Five Device 24 Months", price: 550.00, credits: 40 },
      5022: { name: "Five Device 12 Months", price: 300.00, credits: 20 },
      5023: { name: "Five Device 6 Months", price: 200.00, credits: 12 },
      5024: { name: "Five Device 3 Months", price: 125.00, credits: 10 },
      5025: { name: "Five Device 1 Month", price: 40.00, credits: 5 },

      5026: { name: "Six Device 24 Months", price: 650.00, credits: 48 },
      5027: { name: "Six Device 12 Months", price: 325.00, credits: 24 },
      5028: { name: "Six Device 6 Months", price: 220.00, credits: 18 },
      5029: { name: "Six Device 3 Months", price: 135.00, credits: 12 },
      5030: { name: "Six Device 1 Month", price: 45.00, credits: 6 },

    }
  }],
  ['Titan', {
    color: TITAN_PACKAGE_HEX,
    platform: MEGA_OTT,
    creditCost: 10,
    options: {
      10000: { name: "One Device 24 Months", price: 140.00, credits: 1.8 },
      10001: { name: "One Device 12 Months", price: 90.00, credits: 1 },
      10002: { name: "One Device 6 Months", price: 60.00, credits: 0.5 },
      10003: { name: "One Device 3 Months", price: 35.00, credits: 0.25 },
      10004: { name: "One Device 1 Month", price: 20.00, credits: 0.1 },

      10005: { name: "Two Device 24 Months", price: 230.00, credits: 3.6 },
      10006: { name: "Two Device 12 Months", price: 125.00, credits: 2 },
      10007: { name: "Two Device 6 Months", price: 90.00, credits: 1 },
      10008: { name: "Two Device 3 Months", price: 55.00, credits: 0.5 },
      10009: { name: "Two Device 1 Month", price: 25.00, credits: 0.2 },

      10010: { name: "Three Device 24 Months", price: 290.00, credits: 5.4 },
      10011: { name: "Three Device 12 Months", price: 175.00, credits: 3 },
      10012: { name: "Three Device 6 Months", price: 100.00, credits: 1.5 },
      10013: { name: "Three Device 3 Months", price: 60.00, credits: 0.75 },
      10014: { name: "Three Device 1 Month", price: 30.00, credits: 0.3 },

      10015: { name: "Four Device 24 Months", price: 400.00, credits: 7.2 },
      10016: { name: "Four Device 12 Months", price: 250.00, credits: 4 },
      10017: { name: "Four Device 6 Months", price: 180.00, credits: 2 },
      10018: { name: "Four Device 3 Months", price: 95.00, credits: 1 },
      10019: { name: "Four Device 1 Month", price: 35.00, credits: 0.4 },

      10020: { name: "Five Device 24 Months", price: 550.00, credits: 9 },
      10021: { name: "Five Device 12 Months", price: 300.00, credits: 5 },
      10022: { name: "Five Device 6 Months", price: 200.00, credits: 2.5 },
      10023: { name: "Five Device 3 Months", price: 125.00, credits: 1.25 },
      10024: { name: "Five Device 1 Month", price: 40.00, credits: 0.5 },

      10025: { name: "Six Device 24 Months", price: 650.00, credits: 10.8 },
      10026: { name: "Six Device 12 Months", price: 325.00, credits: 6 },
      10027: { name: "Six Device 6 Months", price: 220.00, credits: 3 },
      10028: { name: "Six Device 3 Months", price: 135.00, credits: 1.5 },
      10029: { name: "Six Device 1 Month", price: 45.00, credits: 0.6 },
    }
  }],
  ['Dust', {
    color: DUST_PACKAGE_HEX,
    platform: STRONG_8K,
    creditCost: 1.87,
    options: {
      16000: { name: "One Device 24 Months", price: 140.00, credits: 24 },
      16001: { name: "One Device 12 Months", price: 90.00, credits: 12 },
      16002: { name: "One Device 6 Months", price: 60.00, credits: 6 },
      16003: { name: "One Device 3 Months", price: 35.00, credits: 3 },
      16004: { name: "One Device 1 Month", price: 20.00, credits: 1 },

      16005: { name: "Two Device 24 Months", price: 230.00, credits: 48 },
      16006: { name: "Two Device 12 Months", price: 125.00, credits: 24 },
      16007: { name: "Two Device 6 Months", price: 90.00, credits: 12 },
      16008: { name: "Two Device 3 Months", price: 55.00, credits: 6 },
      16009: { name: "Two Device 1 Month", price: 25.00, credits: 2 },

      16010: { name: "Three Device 24 Months", price: 290.00, credits: 72 },
      16011: { name: "Three Device 12 Months", price: 175.00, credits: 36 },
      16012: { name: "Three Device 6 Months", price: 100.00, credits: 18 },
      16013: { name: "Three Device 3 Months", price: 60.00, credits: 9 },
      16014: { name: "Three Device 1 Month", price: 30.00, credits: 3 },

      16015: { name: "Four Device 24 Months", price: 400.00, credits: 96 },
      16016: { name: "Four Device 12 Months", price: 250.00, credits: 48 },
      16017: { name: "Four Device 6 Months", price: 180.00, credits: 24 },
      16018: { name: "Four Device 3 Months", price: 95.00, credits: 12 },
      16019: { name: "Four Device 1 Month", price: 35.00, credits: 4 },

      16020: { name: "Five Device 24 Months", price: 550.00, credits: 120 },
      16021: { name: "Five Device 12 Months", price: 300.00, credits: 60 },
      16022: { name: "Five Device 6 Months", price: 200.00, credits: 30 },
      16023: { name: "Five Device 3 Months", price: 125.00, credits: 15 },
      16024: { name: "Five Device 1 Month", price: 40.00, credits: 5 },

      16025: { name: "Six Device 24 Months", price: 650.00, credits: 144 },
      16026: { name: "Six Device 12 Months", price: 325.00, credits: 72 },
      16027: { name: "Six Device 6 Months", price: 220.00, credits: 36 },
      16028: { name: "Six Device 3 Months", price: 135.00, credits: 18 },
      16029: { name: "Six Device 1 Month", price: 45.00, credits: 6 },
    }
  }],
  ['Vengence', {
    color: VENGENCE_PACKAGE_HEX,
    platform: TRILLO,
    creditCost: 1.71,
    options: {
      14001: { name: "One Device 12 Months", price: 90.00, credits: 12 },
      14002: { name: "One Device 6 Months", price: 60.00, credits: 6 },
      14003: { name: "One Device 3 Months", price: 35.00, credits: 3 },
      14004: { name: "One Device 1 Month", price: 20.00, credits: 1 },

      14006: { name: "Two Device 12 Months", price: 125.00, credits: 14 },
      14007: { name: "Two Device 6 Months", price: 90.00, credits: 8 },
      14008: { name: "Two Device 3 Months", price: 55.00, credits: 4 },
      14009: { name: "Two Device 1 Month", price: 25.00, credits: 2 },

      14011: { name: "Three Device 12 Months", price: 175.00, credits: 16 },
      14012: { name: "Three Device 6 Months", price: 100.00, credits: 10 },
      14013: { name: "Three Device 3 Months", price: 60.00, credits: 6 },
      14014: { name: "Three Device 1 Month", price: 30.00, credits: 3 },

      14016: { name: "Four Device 12 Months", price: 250.00, credits: 18 },
      14017: { name: "Four Device 6 Months", price: 180.00, credits: 12 },
      14018: { name: "Four Device 3 Months", price: 95.00, credits: 8 },
      14019: { name: "Four Device 1 Month", price: 35.00, credits: 4 },

      14021: { name: "Five Device 12 Months", price: 300.00, credits: 20 },
      14022: { name: "Five Device 6 Months", price: 200.00, credits: 14 },
      14023: { name: "Five Device 3 Months", price: 125.00, credits: 10 },
      14024: { name: "Five Device 1 Month", price: 40.00, credits: 5 },
    }
  }],

  // NECTAR TV
  ['Nectar', {
    color: NECTAR_PACKAGE_HEX,
    platform: NXT,
    creditCost: 3.80,
    options: {
      6001: { name: "One Device 24 Months", price: 140.00, credits: 8 },
      6002: { name: "One Device 12 Months", price: 90.00, credits: 4 },
      6003: { name: "One Device 6 Months", price: 60.00, credits: 3 },
      6004: { name: "One Device 3 Months", price: 35.00, credits: 2 },
      6005: { name: "One Device 1 Month", price: 20.00, credits: 1 },

      6006: { name: "Two Device 24 Months", price: 230.00, credits: 14 },
      6007: { name: "Two Device 12 Months", price: 125.00, credits: 7 },
      6008: { name: "Two Device 6 Months", price: 90.00, credits: 5 },
      6009: { name: "Two Device 3 Months", price: 55.00, credits: 4 },
      6010: { name: "Two Device 1 Month", price: 25.00, credits: 2 },

      6011: { name: "Three Device 24 Months", price: 290.00, credits: 20 },
      6012: { name: "Three Device 12 Months", price: 175.00, credits: 10 },
      6013: { name: "Three Device 6 Months", price: 100.00, credits: 7 },
      6014: { name: "Three Device 3 Months", price: 60.00, credits: 6 },
      6015: { name: "Three Device 1 Month", price: 30.00, credits: 3 },

      6016: { name: "Four Device 24 Months", price: 400.00, credits: 26 },
      6017: { name: "Four Device 12 Months", price: 250.00, credits: 13 },
      6018: { name: "Four Device 6 Months", price: 180.00, credits: 9 },
      6019: { name: "Four Device 3 Months", price: 95.00, credits: 8 },
      6020: { name: "Four Device 1 Month", price: 35.00, credits: 4 },

      6021: { name: "Five Device 24 Months", price: 550.00, credits: 40 },
      6022: { name: "Five Device 12 Months", price: 300.00, credits: 20 },
      6023: { name: "Five Device 6 Months", price: 200.00, credits: 12 },
      6024: { name: "Five Device 3 Months", price: 125.00, credits: 10 },
      6025: { name: "Five Device 1 Month", price: 40.00, credits: 5 },

      6026: { name: "Six Device 24 Months", price: 650.00, credits: 48 },
      6027: { name: "Six Device 12 Months", price: 325.00, credits: 24 },
      6028: { name: "Six Device 6 Months", price: 220.00, credits: 18 },
      6029: { name: "Six Device 3 Months", price: 135.00, credits: 12 },
      6030: { name: "Six Device 1 Month", price: 45.00, credits: 6 },
    }
  }],
  ['Honey Pot', {
    color: HONEY_POT_PACKAGE_HEX,
    platform: MEGA_OTT,
    creditCost: 10,
    options: {
      11000: { name: "One Device 24 Months", price: 140.00, credits: 1.8 },
      11001: { name: "One Device 12 Months", price: 90.00, credits: 1 },
      11002: { name: "One Device 6 Months", price: 60.00, credits: 0.5 },
      11003: { name: "One Device 3 Months", price: 35.00, credits: 0.25 },
      11004: { name: "One Device 1 Month", price: 20.00, credits: 0.1 },

      11005: { name: "Two Device 24 Months", price: 230.00, credits: 3.6 },
      11006: { name: "Two Device 12 Months", price: 125.00, credits: 2 },
      11007: { name: "Two Device 6 Months", price: 90.00, credits: 1 },
      11008: { name: "Two Device 3 Months", price: 55.00, credits: 0.5 },
      11009: { name: "Two Device 1 Month", price: 25.00, credits: 0.2 },

      11010: { name: "Three Device 24 Months", price: 290.00, credits: 5.4 },
      11011: { name: "Three Device 12 Months", price: 175.00, credits: 3 },
      11012: { name: "Three Device 6 Months", price: 100.00, credits: 1.5 },
      11013: { name: "Three Device 3 Months", price: 60.00, credits: 0.75 },
      11014: { name: "Three Device 1 Month", price: 30.00, credits: 0.3 },

      11015: { name: "Four Device 24 Months", price: 400.00, credits: 7.2 },
      11016: { name: "Four Device 12 Months", price: 250.00, credits: 4 },
      11017: { name: "Four Device 6 Months", price: 180.00, credits: 2 },
      11018: { name: "Four Device 3 Months", price: 95.00, credits: 1 },
      11019: { name: "Four Device 1 Month", price: 35.00, credits: 0.4 },

      11020: { name: "Five Device 24 Months", price: 550.00, credits: 9 },
      11021: { name: "Five Device 12 Months", price: 300.00, credits: 5 },
      11022: { name: "Five Device 6 Months", price: 200.00, credits: 2.5 },
      11023: { name: "Five Device 3 Months", price: 125.00, credits: 1.25 },
      11024: { name: "Five Device 1 Month", price: 40.00, credits: 0.5 },

      11025: { name: "Six Device 24 Months", price: 650.00, credits: 10.8 },
      11026: { name: "Six Device 12 Months", price: 325.00, credits: 6 },
      11027: { name: "Six Device 6 Months", price: 220.00, credits: 3 },
      11028: { name: "Six Device 3 Months", price: 135.00, credits: 1.5 },
      11029: { name: "Six Device 1 Month", price: 45.00, credits: 0.6 },
    }
  }],
  ['Golden', {
    color: GOLDEN_PACKAGE_HEX,
    platform: STRONG_8K,
    creditCost: 1.87,
    options: {
      17000: { name: "One Device 24 Months", price: 140.00, credits: 24 },
      17001: { name: "One Device 12 Months", price: 90.00, credits: 12 },
      17002: { name: "One Device 6 Months", price: 60.00, credits: 6 },
      17003: { name: "One Device 3 Months", price: 35.00, credits: 3 },
      17004: { name: "One Device 1 Month", price: 20.00, credits: 1 },

      17005: { name: "Two Device 24 Months", price: 230.00, credits: 48 },
      17006: { name: "Two Device 12 Months", price: 125.00, credits: 24 },
      17007: { name: "Two Device 6 Months", price: 90.00, credits: 12 },
      17008: { name: "Two Device 3 Months", price: 55.00, credits: 6 },
      17009: { name: "Two Device 1 Month", price: 25.00, credits: 2 },

      17010: { name: "Three Device 24 Months", price: 290.00, credits: 72 },
      17011: { name: "Three Device 12 Months", price: 175.00, credits: 36 },
      17012: { name: "Three Device 6 Months", price: 100.00, credits: 18 },
      17013: { name: "Three Device 3 Months", price: 60.00, credits: 9 },
      17014: { name: "Three Device 1 Month", price: 30.00, credits: 3 },

      17015: { name: "Four Device 24 Months", price: 400.00, credits: 96 },
      17016: { name: "Four Device 12 Months", price: 250.00, credits: 48 },
      17017: { name: "Four Device 6 Months", price: 180.00, credits: 24 },
      17018: { name: "Four Device 3 Months", price: 95.00, credits: 12 },
      17019: { name: "Four Device 1 Month", price: 35.00, credits: 4 },

      17020: { name: "Five Device 24 Months", price: 550.00, credits: 120 },
      17021: { name: "Five Device 12 Months", price: 300.00, credits: 60 },
      17022: { name: "Five Device 6 Months", price: 200.00, credits: 30 },
      17023: { name: "Five Device 3 Months", price: 125.00, credits: 15 },
      17024: { name: "Five Device 1 Month", price: 40.00, credits: 5 },

      17025: { name: "Six Device 24 Months", price: 650.00, credits: 144 },
      17026: { name: "Six Device 12 Months", price: 325.00, credits: 72 },
      17027: { name: "Six Device 6 Months", price: 220.00, credits: 36 },
      17028: { name: "Six Device 3 Months", price: 135.00, credits: 18 },
      17029: { name: "Six Device 1 Month", price: 45.00, credits: 6 },
    }
  }],
  ['Hive', {
    color: HIVE_PACKAGE_HEX,
    platform: TRILLO,
    creditCost: 1.71,
    options: {
      19000: { name: "One Device 24 Months", price: 140.00, credits: 24 },
      19001: { name: "One Device 12 Months", price: 90.00, credits: 12 },
      19002: { name: "One Device 6 Months", price: 60.00, credits: 6 },
      19003: { name: "One Device 3 Months", price: 35.00, credits: 3 },
      19004: { name: "One Device 1 Month", price: 20.00, credits: 1 },

      19005: { name: "Two Device 24 Months", price: 230.00, credits: 48 },
      19006: { name: "Two Device 12 Months", price: 125.00, credits: 14 },
      19007: { name: "Two Device 6 Months", price: 90.00, credits: 8 },
      19008: { name: "Two Device 3 Months", price: 55.00, credits: 4 },
      19009: { name: "Two Device 1 Month", price: 25.00, credits: 2 },

      19010: { name: "Three Device 24 Months", price: 290.00, credits: 72 },
      19011: { name: "Three Device 12 Months", price: 175.00, credits: 16 },
      19012: { name: "Three Device 6 Months", price: 100.00, credits: 10 },
      19013: { name: "Three Device 3 Months", price: 60.00, credits: 6 },
      19014: { name: "Three Device 1 Month", price: 30.00, credits: 3 },

      19015: { name: "Four Device 24 Months", price: 400.00, credits: 96 },
      19016: { name: "Four Device 12 Months", price: 250.00, credits: 18 },
      19017: { name: "Four Device 6 Months", price: 180.00, credits: 12 },
      19018: { name: "Four Device 3 Months", price: 95.00, credits: 8 },
      19019: { name: "Four Device 1 Month", price: 35.00, credits: 4 },

      19020: { name: "Five Device 24 Months", price: 550.00, credits: 120 },
      19021: { name: "Five Device 12 Months", price: 300.00, credits: 20 },
      19022: { name: "Five Device 6 Months", price: 200.00, credits: 14 },
      19023: { name: "Five Device 3 Months", price: 125.00, credits: 10 },
      19024: { name: "Five Device 1 Month", price: 40.00, credits: 5 },

      19025: { name: "Six Device 24 Months", price: 650.00, credits: 144 },
      19026: { name: "Six Device 12 Months", price: 325.00, credits: 72 },
      19027: { name: "Six Device 6 Months", price: 220.00, credits: 36 },
      19028: { name: "Six Device 3 Months", price: 135.00, credits: 18 },
      19029: { name: "Six Device 1 Month", price: 45.00, credits: 6 },
    }
  }],

  // VULTURE TV
  ['Vulture', {
    color: VULTURE_PACKAGE_HEX,
    platform: NXT,
    creditCost: 4.40,
    options: {
      7001: { name: "One Device 24 Months", price: 140.00, credits: 8 },
      7002: { name: "One Device 12 Months", price: 90.00, credits: 4 },
      7003: { name: "One Device 6 Months", price: 60.00, credits: 3 },
      7004: { name: "One Device 3 Months", price: 35.00, credits: 2 },
      7005: { name: "One Device 1 Month", price: 20.00, credits: 1 },

      7006: { name: "Two Device 24 Months", price: 230.00, credits: 14 },
      7007: { name: "Two Device 12 Months", price: 125.00, credits: 7 },
      7008: { name: "Two Device 6 Months", price: 90.00, credits: 5 },
      7009: { name: "Two Device 3 Months", price: 55.00, credits: 4 },
      7010: { name: "Two Device 1 Month", price: 25.00, credits: 2 },

      7011: { name: "Three Device 24 Months", price: 290.00, credits: 20 },
      7012: { name: "Three Device 12 Months", price: 175.00, credits: 10 },
      7013: { name: "Three Device 6 Months", price: 100.00, credits: 7 },
      7014: { name: "Three Device 3 Months", price: 60.00, credits: 6 },
      7015: { name: "Three Device 1 Month", price: 30.00, credits: 3 },

      7016: { name: "Four Device 24 Months", price: 400.00, credits: 26 },
      7017: { name: "Four Device 12 Months", price: 250.00, credits: 13 },
      7018: { name: "Four Device 6 Months", price: 180.00, credits: 9 },
      7019: { name: "Four Device 3 Months", price: 95.00, credits: 8 },
      7020: { name: "Four Device 1 Month", price: 35.00, credits: 4 },

      7021: { name: "Five Device 24 Months", price: 550.00, credits: 40 },
      7022: { name: "Five Device 12 Months", price: 300.00, credits: 20 },
      7023: { name: "Five Device 6 Months", price: 200.00, credits: 12 },
      7024: { name: "Five Device 3 Months", price: 125.00, credits: 10 },
      7025: { name: "Five Device 1 Month", price: 40.00, credits: 5 },

      7026: { name: "Six Device 24 Months", price: 650.00, credits: 48 },
      7027: { name: "Six Device 12 Months", price: 325.00, credits: 24 },
      7028: { name: "Six Device 6 Months", price: 220.00, credits: 18 },
      7029: { name: "Six Device 3 Months", price: 135.00, credits: 12 },
      7030: { name: "Six Device 1 Month", price: 45.00, credits: 6 },
    }
  }],
  ['Shadow', {
    color: SHADOW_PACKAGE_HEX,
    platform: MEGA_OTT,
    creditCost: 10,
    options: {
      12000: { name: "One Device 24 Months", price: 140.00, credits: 1.8 },
      12001: { name: "One Device 12 Months", price: 90.00, credits: 1 },
      12002: { name: "One Device 6 Months", price: 60.00, credits: 0.5 },
      12003: { name: "One Device 3 Months", price: 35.00, credits: 0.25 },
      12004: { name: "One Device 1 Month", price: 20.00, credits: 0.1 },

      12005: { name: "Two Device 24 Months", price: 230.00, credits: 3.6 },
      12006: { name: "Two Device 12 Months", price: 125.00, credits: 2 },
      12007: { name: "Two Device 6 Months", price: 90.00, credits: 1 },
      12008: { name: "Two Device 3 Months", price: 55.00, credits: 0.5 },
      12009: { name: "Two Device 1 Month", price: 25.00, credits: 0.2 },

      12010: { name: "Three Device 24 Months", price: 290.00, credits: 5.4 },
      12011: { name: "Three Device 12 Months", price: 175.00, credits: 3 },
      12012: { name: "Three Device 6 Months", price: 100.00, credits: 1.5 },
      12013: { name: "Three Device 3 Months", price: 60.00, credits: 0.75 },
      12014: { name: "Three Device 1 Month", price: 30.00, credits: 0.3 },

      12015: { name: "Four Device 24 Months", price: 400.00, credits: 7.2 },
      12016: { name: "Four Device 12 Months", price: 250.00, credits: 4 },
      12017: { name: "Four Device 6 Months", price: 180.00, credits: 2 },
      12018: { name: "Four Device 3 Months", price: 95.00, credits: 1 },
      12019: { name: "Four Device 1 Month", price: 35.00, credits: 0.4 },

      12020: { name: "Five Device 24 Months", price: 550.00, credits: 9 },
      12021: { name: "Five Device 12 Months", price: 300.00, credits: 5 },
      12022: { name: "Five Device 6 Months", price: 200.00, credits: 2.5 },
      12023: { name: "Five Device 3 Months", price: 125.00, credits: 1.25 },
      12024: { name: "Five Device 1 Month", price: 40.00, credits: 0.5 },

      12025: { name: "Six Device 24 Months", price: 650.00, credits: 10.8 },
      12026: { name: "Six Device 12 Months", price: 325.00, credits: 6 },
      12027: { name: "Six Device 6 Months", price: 220.00, credits: 3 },
      12028: { name: "Six Device 3 Months", price: 135.00, credits: 1.5 },
      12029: { name: "Six Device 1 Month", price: 45.00, credits: 0.6 },
    }
  }],
  ['Mist', {
    color: MIST_PACKAGE_HEX,
    platform: TRILLO,
    creditCost: 1.71,
    options: {
      18000: { name: "One Device 24 Months", price: 140.00, credits: 24 },
      18001: { name: "One Device 12 Months", price: 90.00, credits: 12 },
      18002: { name: "One Device 6 Months", price: 60.00, credits: 6 },
      18003: { name: "One Device 3 Months", price: 35.00, credits: 3 },
      18004: { name: "One Device 1 Month", price: 20.00, credits: 1 },

      18005: { name: "Two Device 24 Months", price: 230.00, credits: 48 },
      18006: { name: "Two Device 12 Months", price: 125.00, credits: 14 },
      18007: { name: "Two Device 6 Months", price: 90.00, credits: 8 },
      18008: { name: "Two Device 3 Months", price: 55.00, credits: 4 },
      18009: { name: "Two Device 1 Month", price: 25.00, credits: 2 },

      18010: { name: "Three Device 24 Months", price: 290.00, credits: 72 },
      18011: { name: "Three Device 12 Months", price: 175.00, credits: 16 },
      18012: { name: "Three Device 6 Months", price: 100.00, credits: 10 },
      18013: { name: "Three Device 3 Months", price: 60.00, credits: 6 },
      18014: { name: "Three Device 1 Month", price: 30.00, credits: 3 },

      18015: { name: "Four Device 24 Months", price: 400.00, credits: 96 },
      18016: { name: "Four Device 12 Months", price: 250.00, credits: 18 },
      18017: { name: "Four Device 6 Months", price: 180.00, credits: 12 },
      18018: { name: "Four Device 3 Months", price: 95.00, credits: 8 },
      18019: { name: "Four Device 1 Month", price: 35.00, credits: 4 },

      18020: { name: "Five Device 24 Months", price: 550.00, credits: 120 },
      18021: { name: "Five Device 12 Months", price: 300.00, credits: 20 },
      18022: { name: "Five Device 6 Months", price: 200.00, credits: 14 },
      18023: { name: "Five Device 3 Months", price: 125.00, credits: 10 },
      18024: { name: "Five Device 1 Month", price: 40.00, credits: 5 },

      18025: { name: "Six Device 24 Months", price: 650.00, credits: 144 },
      18026: { name: "Six Device 12 Months", price: 325.00, credits: 72 },
      18027: { name: "Six Device 6 Months", price: 220.00, credits: 36 },
      18028: { name: "Six Device 3 Months", price: 135.00, credits: 18 },
      18029: { name: "Six Device 1 Month", price: 45.00, credits: 6 },
    }
  }],

  // ── App Services ────────────────────────────────────────────────────────────
  ['TiviMate Access', {
    color: TIVIMATE_ACCESS_HEX,
    platform: APP_SERVICES,
    creditCost: 0,
    options: {
      20001: { name: "1 Year", price: 75.00, credits: 0 },
    }
  }],
  ['TiviMate Branded', {
    color: TIVIMATE_BRANDED_HEX,
    platform: APP_SERVICES,
    creditCost: 0,
    options: {
      20101: { name: "1 Year", price: 125.00, credits: 0 },
    }
  }],
  ['IBO Pro Access', {
    color: IBO_ACCESS_HEX,
    platform: APP_SERVICES,
    creditCost: 0,
    options: {
      21001: { name: "1 Year", price: 75.00, credits: 0 },
    }
  }],
  ['IBO Pro Branded', {
    color: IBO_BRANDED_HEX,
    platform: APP_SERVICES,
    creditCost: 0,
    options: {
      21101: { name: "1 Year", price: 125.00, credits: 0 },
    }
  }],
  ['Smarters Access', {
    color: SMARTERS_ACCESS_HEX,
    platform: APP_SERVICES,
    creditCost: 0,
    options: {
      22001: { name: "1 Year", price: 75.00, credits: 0 },
    }
  }],
  ['Smarters Branded', {
    color: SMARTERS_BRANDED_HEX,
    platform: APP_SERVICES,
    creditCost: 0,
    options: {
      22101: { name: "1 Year", price: 125.00, credits: 0 },
    }
  }],
  ['XCIPTV Access', {
    color: XCIPTV_ACCESS_HEX,
    platform: APP_SERVICES,
    creditCost: 0,
    options: {
      23001: { name: "1 Year", price: 75.00, credits: 0 },
    }
  }],
  ['XCIPTV Branded', {
    color: XCIPTV_BRANDED_HEX,
    platform: APP_SERVICES,
    creditCost: 0,
    options: {
      23101: { name: "1 Year", price: 125.00, credits: 0 },
    }
  }],
]);

function getPackageColor(packageId) {
  for (const [, { color, options }] of packages) {
    if (options[packageId]) {
      return color;
    }
  }
  return "#6c757d";
}

function getPackageName(packageId) {
  for (const [, { name, options }] of packages) {
    if (options[packageId]) {
      return options[packageId].name;
    }
  }
  return "N/A";
}

function getPackagePrice(packageId) {
  for (const [, { price, options }] of packages) {
    if (options[packageId]) {
      return options[packageId].price;
    }
  }
  return 0;
}

function getPackageCredits(packageId) {
  for (const [, { options }] of packages) {
    if (options[packageId]) {
      return options[packageId].credits;
    }
  }
  return 0;
}

function getPackageProfit(packageId) {
  for (const [, { creditCost, options }] of packages) {
    if (options[packageId]) {
      return options[packageId].price - (options[packageId].credits * creditCost).toFixed(2);
    }
  }
  return 0;
}

function getPackageTitle(packageId) {
  for (const [name, { options }] of packages) {
    if (options[packageId]) {
      return name;
    }
  }
  return null;
}

/** Parses the duration in months out of a package's name (e.g. "One Device 12 Months" -> 12) */
function getPackageDurationMonths(packageId) {
  const name = getPackageName(packageId);
  const match = /(\d+)\s*Months?/i.exec(name);
  return match ? Number(match[1]) : null;
}

export function PackageSelect({ onChange, value }) {
  return (
    <>
      <option value="" className="text-muted">Select a package</option>
      {Array.from(packages.entries()).map(([packageType, { color, options }]) => (
        <optgroup
          key={packageType}
          label={packageType.split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ')}
          className="text-white"
        >
          {Object.entries(options).map(([id, { name, price }]) => (
            <option
              key={id}
              value={id}
            >
              {name} - €{price.toFixed(2)}
            </option>
          ))}
        </optgroup>
      ))}
    </>
  );
}

/** Returns the tier name that contains a given package ID */
export function getPackageTier(packageId) {
  for (const [name, { options }] of packages) {
    if (options[packageId]) return name;
  }
  return "";
}

/** Returns the platform display name for a given package ID */
export function getPackagePlatform(packageId) {
  for (const [, { platform, options }] of packages) {
    if (options[packageId]) return PLATFORM_NAMES[platform] ?? "";
  }
  return "";
}

/** Returns the platform display name for a given tier name */
export function getPackagePlatformByTier(tierName) {
  const platform = packages.get(tierName)?.platform;
  return platform != null ? (PLATFORM_NAMES[platform] ?? "") : "";
}

/** <option> elements for the tier picker (step 1) */
export function PackageTierSelect() {
  return (
    <>
      <option value="">Select package type…</option>
      {Array.from(packages.keys()).map(name => (
        <option key={name} value={name}>{name} · {getPackagePlatformByTier(name)}</option>
      ))}
    </>
  );
}

/** <option> elements for a specific tier's options (step 2) */
export function PackageTierOptionsSelect({ tier }) {
  const tierData = packages.get(tier);
  if (!tierData) return <option value="">Select type first…</option>;
  return (
    <>
      <option value="">Select package…</option>
      {Object.entries(tierData.options).map(([id, { name, price }]) => (
        <option key={id} value={id}>{name} – €{price.toFixed(2)}</option>
      ))}
    </>
  );
}

export function getPackageCreditRate(tierName) {
  return packages.get(tierName)?.creditCost ?? null;
}

/** Returns true when the tier belongs to the App Services platform */
export function isAppServiceTier(tierName) {
  return packages.get(tierName)?.platform === APP_SERVICES;
}

/** Returns true when a package ID belongs to the App Services platform */
export function isAppServicePackage(packageId) {
  for (const [, { platform, options }] of packages) {
    if (options[packageId]) return platform === APP_SERVICES;
  }
  return false;
}

/** All tier names, in catalog order — the single source of truth for any tier filter UI */
export function getAllTierNames() {
  return Array.from(packages.keys());
}

/** Returns a tier's accent color (used for filter chips etc.), or a neutral fallback */
export function getTierColor(tierName) {
  return packages.get(tierName)?.color ?? "#6c757d";
}

export { getPackageColor, getPackageName, getPackagePrice, getPackageProfit, getPackageTitle, getPackageDurationMonths, getPackageCredits };
